// Minimal Vietnamese summary used as the share text for the Zalo
// share tile and the mobile More sheet's "Chia sẻ Zalo" row. Mirrors
// what `formatPropertySummary` produces; duplicated here so the
// detail surfaces don't have to import the broader share lib.

import { formatPrice } from "@/features/property/utils/format-price";
import type { Property } from "@/types/property";

export function formatPropertyShareText(
  property: Property,
  agentName: string | undefined,
): string {
  const title = property.buildingName ?? "Bất động sản";
  const price = formatPrice(property.price, property.listingType);
  const ward = property.wardDisplayName;
  const lines = [
    title,
    `Giá: ${price}`,
    `Vị trí: ${ward}`,
    `Diện tích: ${property.area}m²`,
  ];
  if (agentName) lines.push(`Liên hệ: ${agentName}`);
  return lines.join("\n");
}
